module.exports = __webpack_public_path__ + "img/arr-sm-down-icon.7ae69558.svg";